import React, { useRef, useState } from "react";

const CopyToClipboard = ({ children, value, tooltipText = "Copied!" }) => {
  const wrapperRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const content = children || value;

  const handleCopy = async () => {
    let textToCopy = "";

    if (value) {
      textToCopy = value;
    } else if (wrapperRef.current) {
      const temp = document.createElement("div");
      temp.appendChild(wrapperRef.current.cloneNode(true));
      textToCopy = temp.textContent?.trim() || "";
    }

    if (!textToCopy) return;

    try {
      await navigator.clipboard.writeText(textToCopy);
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 1500);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <span
      ref={wrapperRef}
      onClick={handleCopy}
      onKeyDown={(e) =>
        e.key === "Enter" || e.key === " " ? handleCopy() : null
      }
      tabIndex={0}
      role="button"
      title="Click to copy"
      style={{
        position: "relative",
        display: "inline-block",
        // cursor: "pointer",
        outline: "none",
      }}
    >
      {content}
      {showTooltip && (
        <div
          style={{
            position: "absolute",
            top: "-1.5rem",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "2px 6px",
            fontSize: "0.75rem",
            borderRadius: "4px",
            whiteSpace: "nowrap",
            pointerEvents: "none",
            opacity: 0.9,
            zIndex: 1000,
          }}
        >
          {tooltipText}
        </div>
      )}
    </span>
  );
};

export default CopyToClipboard;
